var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSampleCalendarIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83398 2.49967H1.50065C1.27964 2.49967 1.06767 2.58747 0.911394 2.74375C0.755114 2.90003 0.667316 3.11199 0.667316 3.33301V16.6663C0.667316 16.8874 0.755114 17.0993 0.911394 17.2556C1.06767 17.4119 1.27964 17.4997 1.50065 17.4997H16.5007C16.7217 17.4997 16.9336 17.4119 17.0899 17.2556C17.2462 17.0993 17.334 16.8874 17.334 16.6663V3.33301C17.334 3.11199 17.2462 2.90003 17.0899 2.74375C16.9336 2.58747 16.7217 2.49967 16.5007 2.49967H13.1673V0.833008H11.5007V2.49967H6.50065V0.833008H4.83398V2.49967ZM2.33398 9.16634H15.6673V15.833H2.33398V9.16634ZM6.50065 4.16634H11.5007V5.83301H13.1673V4.16634H15.6673V7.49967H2.33398V4.16634H4.83398V5.83301H6.50065V4.16634ZM14.0007 10.833H12.334V12.4997H14.0007V10.833ZM9.83398 10.833H8.16732V12.4997H9.83398V10.833Z",
    fill: "#19305A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSampleCalendarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SampleCalendarIcon.2b633e0a.svg";
export { ForwardRef as ReactComponent };